// src/theme/palette.js
// Color palette configuration for MUI theme
// All comments in English only

export const palette = {
  primary: {
    main: '#218EF4', // Blue - your existing primary color
    light: '#6BB6FF', // Light blue variant
    dark: '#1565C0', // Dark blue variant
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#333333', // Dark gray - your existing secondary color
    light: '#757575',
    dark: '#212121',
    contrastText: '#ffffff',
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#000000',
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#ffffff',
  },
  success: {
    main: '#51D26A',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#ffffff',
  },
  background: {
    default: '#FFFFFF',
    paper: '#ffffff',
  },
  text: {
    primary: '#1a1a1a', // Updated to match design
    secondary: '#9d9d9d', // Updated to match design  
    disabled: '#bdbdbd',
  },
  divider: '#dbdbdb', // Updated to match design
  action: {
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  // Custom colors for the design
  custom: {
    // Avatar colors array
    avatarColors: [
      '#ed5191', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', 
      '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43', 
      '#10AC84', '#EE5A24', '#0984E3', '#6C5CE7', '#FD79A8'
    ],
    // Danger/Remove color
    danger: '#ed1b0b',
  },
};

// Dark mode palette
export const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#4FC3F7', // Light blue for dark mode
    light: '#81D4FA',
    dark: '#29B6F6',
    contrastText: '#000000',
  },
  secondary: {
    main: '#ffffff',
    light: '#ffffff',
    dark: '#cccccc',
    contrastText: '#000000',
  },
  success: {
    main: '#51D26A',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#ffffff',
  },
  background: {
    default: '#121212',
    paper: '#1e1e1e',
  },
  text: {
    primary: '#ffffff',
    secondary: '#b3b3b3',
    disabled: '#666666',
  },
  divider: '#333333',
  // Custom colors for the design (same for dark mode)
  custom: {
    // Avatar colors array
    avatarColors: [
      '#ed5191', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', 
      '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43', 
      '#10AC84', '#EE5A24', '#0984E3', '#6C5CE7', '#FD79A8'
    ],
    // Danger/Remove color
    danger: '#ed1b0b',
  },
}; 